import {
  Component,
  Input,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import {
  CommonModule,
  NgOptimizedImage,
  isPlatformBrowser,
} from '@angular/common';
import SwiperCore, {
  A11y,
  Autoplay,
  Navigation,
  Pagination,
  Scrollbar,
  SwiperOptions,
} from 'swiper';
import { SwiperModule } from 'swiper/angular';
import { HotelsCardComponent } from '../../../pages/home/components/hotels-card/hotels-card.component';
import { ISwiperConfigs } from '@core/models/domains/slider.model';
import { ChainHotelsComponent } from '../../../pages/home/sections/chain-hotels/chain-hotels.component';

// install Swiper modules
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);
@Component({
  selector: 'iho-swiper',
  standalone: true,
  imports: [
    CommonModule,
    SwiperModule,
    HotelsCardComponent,
    NgOptimizedImage,
    ChainHotelsComponent,
  ],
  templateUrl: './swiper.component.html',
  styleUrls: ['./swiper.component.scss'],
})
export class IhoSwiperComponent {
  isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  @Input({ required: true }) configs!: ISwiperConfigs;
  @Input({ required: true }) dataSource!: any;
}
